@if(selectedRead){
<div class="overlay" (click)="toggleModal()"></div>
<div class="container-popup flex-column m-0 p-0 d-flex">
    <div class="row g-0 m-0 p-4 justify-content-start borderb">
        <div class="col-md-11 ps-2 d-flex justify-content-start">
            <span class="popup-title">{{"COMMAND" | translate}} {{"MESSAGE" | translate}}</span>
        </div>
        <div class="col-md-1 d-flex justify-content-end" (click)="toggleModal()">
            <svg-icon alt="Exit" class="exit" role="button" src="assets/device/exit.svg"></svg-icon>
        </div>
    </div>
    <div class="row g-0 m-0 body">
        <div class="alert-description p-3 mt-3 mb-2">
            <span class="label-box-information">{{ selectedRead.errorMessage || '/' }}</span>
        </div>
    </div>
    <div class="row g-0 m-0 p-3 align-items-end bordert mt-auto">
        <div class="col-md-9 pt-2 pb-2 ps-2 d-flex justify-content-start" (click)="toggleModal()">
            <span role="button" class="item-name">{{
                "CLOSE_WINDOW" | translate
                }}</span>
        </div>
    </div>
</div>
}

<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="row g-0 m-0 d-flex align-items-center mt-3 pt-4 pb-3">
            <div class="col-md-1 d-flex pe-4 justify-content-end">
                <div class="button-back" (click)="goBack()">
                    <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
                </div>
            </div>
            <div class="col-md-6 pb-2">
                <h2 class="col pb-2 m-0 title">
                    {{"SCHEDULERLOGS_COMMAND_REPORT" | translate}}
                </h2>
                <h6 class="col subtitle">
                    {{"SCHEDULERLOGS_COMMAND_REPORT_SUBTITLE" | translate}}
                </h6>
            </div>
            <div class="col-md-5 d-flex justify-content-end pe-5">
                <button class="add" (click)="download()">
                    {{ "DOWNLOAD" | translate }}
                </button>
            </div>
        </div>
        <div class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-2 pb-2">
            <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
            <app-status [statuses]="commandStatuses" class="pe-2" (close)="onStatusOption($event)"></app-status>
            <div class="button-wrapper pe-2">
                <div class="button">
                    <img alt="Date" src="assets/core/table-button/date.svg" />
                    <div class="button-text" (click)="toggleDatepicker()"
                        [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
                        <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                            {{ selectedDate }}
                        </ng-container>
                        <ng-template #noDateSelected>
                            <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                        </ng-template>
                    </div>
                    <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit" src="assets/device/x.svg"
                        (click)="clearDates()" />
                </div>
            </div>
            @if (isDatepickerOpen) {
            <div class="overlay" (click)="toggleDatepicker()"></div>
            <app-datepicker [scale]="1.2" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
                [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-datepicker>
            }
            <app-search class="pe-2" placeholder="{{ 'SCHEDULED_DATA_SEARCHBY' | translate }}"
                (searchChange)="searchChange($event)">
            </app-search>
        </div>
        <div class="row g-0 m-0 pt-3">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{"SCHEDULER" | translate}} {{"TIMESTAMP" | translate}}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{"DEVICESETUP_METERNO" | translate}}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{"STARTTIME" | translate}}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{"END" | translate}} {{"TIME" | translate}}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{"STATUS" | translate}}</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of data; let i=index" (click)="handleRowClick(row)">
                        <td></td>
                        <td>
                            <span>{{row.schedulerStartTime | date: "dd MMM yyyy, h:mm:ss a"}}</span>
                        </td>
                        <td>
                            <span (click)="clipboardService.copyToClipboard(row.meterNumber!, $event)" class="copyable">
                                {{ row.meterNumber }}
                                <span class="copy-tooltip"
                                    *ngIf="clipboardService.copiedText === row.meterNumber">{{"COPIED" |
                                    translate}}</span>
                            </span>
                        </td>
                        <td>
                            <span>{{row.startTime | date: "dd MMM yyyy, h:mm:ss a"}}</span>
                        </td>
                        <td>
                            <span>{{row.endTime | date: "dd MMM yyyy, h:mm:ss a"}}</span>
                        </td>
                        <td>
                            <span class="text-wrapper" [ngClass]="{
                    'status-pending': row.status === 'Pending',
                    'status-completed': row.status === 'Success',
                    'status-failed': row.status === 'Failed',
                    'status-fatal-error': row.status === 'ErrorOccured',
                  }">
                                {{ row.status === 'ErrorOccured' ? ('FATAL_ERROR' | translate) : row.status }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="container-down">
        <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfCommands" [pageSize]="pageSize"
            [currentPage]="currentPage" (pageChange)="pageChange($event)">
        </app-pagination>
    </div>
</div>